import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import Logo from "../../components/Logo";
import { Seo } from "../../components/Seo";
import { api, setToken, getToken, errorMessage } from "../../api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (getToken()) return <Navigate to="/admin/blog" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      nav("/admin/blog", { replace: true });
    } catch (err) {
      setError(errorMessage(err, "Could not sign in"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--fr-bg)] flex items-center justify-center px-5" data-testid="admin-login-page">
      <Seo title="Admin sign in" noindex />
      <div className="w-full max-w-[420px]">
        <div className="flex justify-center">
          <Logo height={28} />
        </div>
        <form onSubmit={submit} className="card p-8 mt-8 fade-up">
          <div className="w-11 h-11 rounded-xl bg-[var(--fr-primary-tint)] text-[var(--fr-primary-dark)] flex items-center justify-center">
            <Lock size={18} />
          </div>
          <h1 className="font-display font-bold text-2xl mt-5">Admin sign in</h1>
          <p className="text-sm text-[var(--fr-muted)] mt-1">Manage blog posts and demo requests.</p>
          <label className="block mt-6 text-sm font-medium">
            Email
            <input className="fr-input mt-1.5" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
          </label>
          <label className="block mt-4 text-sm font-medium">
            Password
            <input className="fr-input mt-1.5" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
          </label>
          {error && (
            <p className="mt-4 text-sm text-red-600 bg-red-50 border border-red-100 rounded-xl px-3 py-2" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button type="submit" disabled={busy} className="btn btn-primary btn-lg w-full mt-6 disabled:opacity-60" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign in"} <ArrowRight size={17} className="ml-1" />
          </button>
        </form>
      </div>
    </div>
  );
}
